module.exports = __webpack_public_path__ + "images/confidence-interval-04-desktop.webp";